<script>
	import VideoHeader from '$lib/components/platform/pages/videos/VideoHeader.svelte';
	import PickSlider from '$lib/components/platform/pages/videos/PickSlider.svelte';
	export let data;
</script>

<VideoHeader></VideoHeader>

<slot />
